(() => {
  if (window.ssWishlist) return;

  const key = 'securedstuff:wishlist:v1';
  const selector = '[data-ss-wishlist-toggle]';
  const labels = window.ssThemeWishlistLabels;

  function read() {
    const value = JSON.parse(localStorage.getItem(key) || '[]');

    if (!Array.isArray(value)) return [];

    return [...new Set(value.filter(
      handle => typeof handle === 'string' && handle.length > 0
    ))];
  }

  function updateButtons() {
    let saved;

    try {
      saved = new Set(read());
    } catch (error) {
      return;
    }
    const countText = String(saved.size);
    document.querySelectorAll('[data-ss-wishlist-count]').forEach(counter => {
      if (counter.textContent !== countText) {
        counter.textContent = countText;
      }
      if (counter.hidden) counter.hidden = false;
    });

    const headerLabel = labels.count.replace('__COUNT__', String(saved.size));
    document.querySelectorAll('.ss-wishlist-link').forEach(link => {
      if (link.getAttribute('aria-label') !== headerLabel) {
        link.setAttribute('aria-label', headerLabel);
      }
    });

    document.querySelectorAll(selector).forEach(button => {
      const active = saved.has(button.dataset.productHandle);

      button.setAttribute('aria-pressed', String(active));
      button.setAttribute(
        'aria-label',
        active ? labels.remove : labels.add
      );
      button.classList.toggle('is-saved', active);
    });
  }

  function toggle(handle) {
    if (!handle) return false;

    try {
      const saved = read();
      const index = saved.indexOf(handle);

      if (index === -1) {
        saved.push(handle);
      } else {
        saved.splice(index, 1);
      }

      localStorage.setItem(key, JSON.stringify(saved));
      updateButtons();

      document.dispatchEvent(
        new CustomEvent('ss:wishlist-changed', {
          detail: { handles: saved.slice() }
        })
      );

      return true;
    } catch (error) {
      window.alert(
        labels.error
      );

      return false;
    }
  }

  window.ssWishlist = {
    getHandles: read,
    toggle,
    refresh: updateButtons
  };

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest(selector);
    if (!button || button.disabled) return;

    event.preventDefault();
    toggle(button.dataset.productHandle);
  });

  window.addEventListener('storage', event => {
    if (event.key === key || event.key === null) {
      updateButtons();
      document.dispatchEvent(new Event('ss:wishlist-changed'));
    }
  });

  document.addEventListener('shopify:section:load', updateButtons);

  let refreshQueued = false;

  const observer = new MutationObserver(records => {
    const buttonsAdded = records.some(record =>
      [...record.addedNodes].some(node =>
        node instanceof Element &&
        (node.matches(selector) || node.querySelector(selector))
      )
    );

    if (!buttonsAdded || refreshQueued) return;

    refreshQueued = true;
    requestAnimationFrame(() => {
      refreshQueued = false;
      updateButtons();
    });
  });

  function init() {
    updateButtons();
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();